<template>
  <div class="recruit-wrapper">
    <!-- pc -->
    <div class="recruit-index-wrapper hidden-sm-and-down" v-show="$route.meta.showRecruitIndex" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="recruit-banner" :style="{backgroundImage:'url('+ bannerBg +')'}">
        <div class="banner-content">
          <div class="title">
            <img src="../../../../static/images/title01.png" alt="选择和风就职圆你日本工作梦">
          </div>
          <div class="titleDesc">
            <img src="../../../../static/images/recruitDesc.png" alt="日本で働く夢を叶えよ！">
          </div>
          <div class="search">
            <input type="text" v-model="SearchTxt" @change="changeSearchTxt" placeholder="例：SOFT BANK" @keyup.enter="searchFilterClick">
            <button @click="searchFilterClick">搜索</button>
          </div>
          <div class="desc">
            <a href="javascript:;" v-for="(item,index) in descItems" :key="index" :class="index == searchActive?'active':''" @click="searchItemClick(index)">{{item}}</a>
          </div>
        </div>
      </div>
      <div class="recruit-nav-wrap">
        <div class="recruit-nav">
          <ul class="adress clearfix">
            <li>工作地点：</li>
            <li v-for="(item,index) in adressArr" :key="index" :class="index == adressActive?'active':''" @click="adressItemClick(index)">{{item}}</li>
          </ul>
          <ul class="work clearfix">
            <li>职位类型：</li>
            <li v-for="(item,index) in workArr" :key="index" :class="index == workActive?'active':''" @click="workItemClick(index)">{{item}}</li>
          </ul>
          <div class="filter-nav clearfix">
            <div>
              <span v-for="(item,index) in filterNav" :key="index" :class="index == filterActive?'active':''" @click="filterItemClick(index)">{{item}}</span>
            </div>
            <p>
              为您优先
              <span>{{total}}</span> 个放心职位
            </p>
          </div>
        </div>
      </div>

      <div class="recruit-list">
        <ul class="clearfix">
          <li v-for="(item,index) in recruitDataArr" class="clearfix">
            <div class="list-con">
              <router-link :to="{name:'recruitDetail',query:{sysno:item.SysNo,tab:1} }">
                <h3 class="title">{{item.PositionName}}</h3>
                <div class="content">
                  <span class="price">{{item.MonthlySalary}} 月给</span>
                  <span class="tag">{{item.PositionCategory}}</span>
                  <span class="adress">{{item.Area}} 日语水平:{{item.Rynl}}</span>
                </div>
                <p class="desc">
                  <span v-for="tagItem in item.JobTag">{{tagItem}}</span>
                </p>
              </router-link>
            </div>
            <div class="list-logo">
              <div class="img-box">
                <img :src="item.CompanyLogo" alt="公司logo" v-if="item.CompanyLogo">
              </div>
              <p class="time">{{newDate}}</p>
            </div>
            <div class="list-company clearfix">
              <div class="company-box">
                <p class="company-name">{{item.CompanyMoHuName}}</p>
                <p class="button" @click="toRecruitDetailJL(item.SysNo)">应聘</p>
              </div>
            </div>
          </li>
          <li v-if="recruitDataArr.length == 0" class="noneData">暂未检索到符合条件的信息，请重新筛选。</li>
          <li class="bottomLine" v-else>== 我是有底线的 ==</li>
        </ul>
      </div>
    </div>

    <!-- m -->
    <div class="m-recruit-index-wrapper hidden-md-and-up" v-show="$route.meta.showRecruitIndex" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="m-recruit-nav">
        <ul class="clearfix">
          <li v-for="(item,index) in mFilterNav" @click="navDropDown(index)">
            <p>
              <span>
                {{item}}
                <img src="../../../../static/images/recruit/down.png">
              </span>
            </p>
          </li>
        </ul>
        <ol class="dropDown">
          <li v-for="(item,index) in chooseListTxtArr[0]" :class="index == chooseListTxtActive01?'active':''" @click="dropDownChoose01(index)">
            {{item}}
            <img src="../../../../static/images/recruit/right.png">
          </li>
        </ol>
        <ol class="dropDown">
          <li v-for="(item,index) in chooseListTxtArr[1]" :class="index == chooseListTxtActive02?'active':''" @click="dropDownChoose02(index)">
            {{item}}
            <img src="../../../../static/images/recruit/right.png">
          </li>
        </ol>
        <ol class="dropDown">
          <li v-for="(item,index) in chooseListTxtArr[2]" :class="index == chooseListTxtActive03?'active':''" @click="dropDownChoose03(index)">
            {{item}}
            <img src="../../../../static/images/recruit/right.png">
          </li>
        </ol>
      </div>

      <ul class="m-content-wrapper clearfix">
        <li v-for="(item,index) in recruitDataArr" class="clearfix">
          <div class="left-content">
            <router-link tag="a" :to="{name:'recruitDetail',query:{sysno:item.SysNo,tab:1} }">
              <h3 class="title">{{item.PositionName}}</h3>
              <div class="content">
                <span class="tag">{{item.PositionCategory}}</span>
                <span class="adress">{{item.Adress}} 日本水平:{{item.Rynl}}</span>
              </div>
              <p class="desc">
                <span v-for="tagItem in item.JobTag">{{tagItem}}</span>
              </p>
              <p class="time">{{newDate}}</p>
            </router-link>
          </div>
          <div class="right-content">
            <span>{{item.MonthlySalary}} 月给</span>
            <p class="button" @click="toForm(item.PositionName)">应聘</p>
          </div>
        </li>
        <li v-if="recruitDataArr.length == 0" class="m-noneData">暂未检索到符合条件的信息，请重新筛选。</li>
        <li class="bottomLine" v-else>== 我是有底线的 ==</li>
      </ul>
    </div>

    <!-- 详情页 -->
    <router-view></router-view>
  </div>
</template>

<script>
const jsonp = require("jsonp");
import bannerBg from "../../../../static/images/recruit/banner.jpg";
let p = 0;
export default {
  data () {
    return {
      bannerBg: bannerBg,
      fullscreenLoading: true,
      searchActive: null,
      adressActive: 0,
      workActive: 0,
      filterActive: 0,
      SearchTxt: "",
      total: 0,
      flag: false,

      descItems: [
        "包吃包住",
        "月薪最高",
        "有奖金",
        "知名企业",
        "交通费报销",
        "无经验可"
      ],
      adressArr: ["全部", "東京都", "神奈川県", "埼玉県", "千葉県", "其他"],
      workArr: [
        "全部",
        "一般事务",
        "销售",
        "餐饮",
        "贩卖",
        "服务接待",
        "建筑装修",
        "IT相关",
        "工厂",
        "司机"
      ],
      filterNav: ["综合排序", "最新发布", "最高薪酬"],
      recruitDataArr: [],

      mFilterNav: ["综合排序", "工作地点", "职位类型"],
      chooseListTxtActive01: 0,
      chooseListTxtActive02: 0,
      chooseListTxtActive03: 0,
      chooseListTxtArr: [
        ["综合排序", "薪资最高", "最新发布"],
        ["工作地点", "東京都", "神奈川県", "埼玉県", "千葉県", "其他"],
        [
          "职位类型",
          "一般事务",
          "销售",
          "餐饮",
          "贩卖",
          "服务接待",
          "建筑装修",
          "IT相关",
          "工厂",
          "司机"
        ]
      ],
      options: {
        SearchTxt: "",
        AraeName: "",
        WorkType: "",
        SortType: "",
        PageSize: 10,
        PageIndex: 1
      }
    };
  },
  created () {
    let _this = this;
    // console.log("首页搜索参数",_this.$route.query)
    // 首页搜索 职位
    if (_this.$route.query.searchJob != undefined) {
      _this.SearchTxt = decodeURI(this.$route.query.searchJob);
      _this.options.SearchTxt = decodeURI(this.$route.query.searchJob);
    }
    // 首页搜索 地区
    if (_this.$route.query.searchArea != undefined) {

      _this.options.AraeName = decodeURI(this.$route.query.searchArea);

      // 如果地区匹配的 有工作地点中的 条件 就高亮
      Array.prototype.indexVf = function (arr) {
        for (var i = 0; i < this.length; i++) {
          if (this[i] == arr) {
            return i;
          }
        }
      }

      let _index = _this.adressArr.indexVf(decodeURI(_this.$route.query.searchArea)); //得到1在aa中的下标0
      if (_index == undefined) {
        _index = 0
      }

      _this.adressActive = _index;

    }

    _this.getData(_this.options);

    window.addEventListener("scroll", this.handleScroll, true);

  },
  beforeDestroy () {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    getData (filterOptions) {
      let _this = this;
      this.$axios
        .get("../../../../static/json/recruitData.json")
        .then(res => {
          // console.log("success",res)
          if (res.data.length > 0) {
            let filterDataArr = res.data;

            // 先筛选数据
            filterDataArr = _this.queryData(filterOptions, filterDataArr);
            // console.log('筛选之前',filterDataArr)

            // 再滚动加载
            filterDataArr = filterDataArr.slice(
              0,
              _this.options.PageSize * _this.options.PageIndex
            );
            // console.log('筛选之后',filterDataArr)

            _this.total = res.data.length;

            _this.recruitDataArr = filterDataArr;

            _this.options.PageIndex++; //数据获取成功 页数增加  用页数控制显示的pageSize 数量 就是滚动无限加载的原理

            _this.fullscreenLoading = false;

            // console.log("new data",filterDataArr);
          }
        })
        .catch(err => {
          console.log("error", err);
          _this.fullscreenLoading = false;
          _this.$message.error("加载失败，暂无法显示更多数据，请稍后重试");
        });
    },
    toRecruitDetailJL (sysno) {
      this.$router.push({
        name: "recruitDetail",
        query: { sysno: sysno, tab: 2 }
      });
    },
    // 移动端 应聘直接跳转到表单页面 传入公司名称和职位
    toForm (componyJob) {
      this.$router.push({
        name: "form",
        query: { componyJob: encodeURI(componyJob) }
        // query: {componyJob: componyJob }
        // query: { componyName: encodeURI(componyName), componyJob: encodeURI(componyJob) }
      });
    },

    // 滚动 事件
    handleScroll (e) {
      let _this = this;
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let scrollHeight = document.body.clientHeight; //文档高度
      let windowHeight = document.documentElement.clientHeight; //浏览器默认高度

      // pc 吸顶效果
      let topConH = Number($(".top-content").height());
      let boxH = Number($(".recruit-banner").height());

      if (scrollTop >= boxH - topConH) {
        $(".recruit-nav").css({
          position: "fixed",
          top: topConH
        });
      } else {
        $(".recruit-nav").css({
          position: "relative",
          top: "0"
        });
      }

      // 移动端 吸顶效果
      if (scrollTop > topConH) {
        $(".m-recruit-nav").css({
          position: "fixed",
          top: 0
        });
      } else {
        $(".m-recruit-nav").css({
          position: "static",
          top: 0
        });
      }

      // 滚动加载
      if (scrollTop + windowHeight >= scrollHeight - 500) {
        _this.getData(_this.options);
        // _this.options.PageIndex++ ;  //数据获取成功 页数增加  用页数控制显示的pageSize 数量 就是滚动无限加载的原理
      }
    },

    // 移动端 下拉导航点击事件
    navDropDown (index) {
      if (
        !$(".m-recruit-nav>ul>li")
          .eq(index)
          .hasClass("active")
      ) {
        $(".m-recruit-nav>ul>li")
          .removeClass("active")
          .eq(index)
          .addClass("active");
        $(".dropDown")
          .hide()
          .eq(index)
          .slideDown();
      } else {
        $(".m-recruit-nav>ul>li")
          .eq(index)
          .removeClass("active");
        $(".dropDown")
          .eq(index)
          .hide();
      }
    },
    // 移动端 下拉导航的选项 综合排序
    dropDownChoose01 (index) {
      let _this = this;

      _this.chooseListTxtActive01 = index;
      _this.mFilterNav[0] = _this.chooseListTxtArr[0][index];

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      if (_this.mFilterNav[0] == "综合发布") {
        _this.options.SortType = "";
      } else {
        _this.options.SortType = _this.mFilterNav[0];
      }
      _this.getData(_this.options);

      $(".m-recruit-nav>ul>li").removeClass("active");
      $(".dropDown").hide();
    },
    // 工作地点
    dropDownChoose02 (index) {
      let _this = this;
      _this.chooseListTxtActive02 = index;
      _this.mFilterNav[1] = _this.chooseListTxtArr[1][index];

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      if (_this.mFilterNav[1] == "工作地点") {
        _this.options.AraeName = "";
      } else {
        _this.options.AraeName = _this.mFilterNav[1];
      }
      _this.getData(_this.options);

      $(".m-recruit-nav>ul>li").removeClass("active");
      $(".dropDown").hide();
    },
    // 职位类型
    dropDownChoose03 (index) {
      let _this = this;

      _this.chooseListTxtActive03 = index;
      _this.mFilterNav[2] = _this.chooseListTxtArr[2][index];

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      if (_this.mFilterNav[2] == "职位类型") {
        _this.options.WorkType = "";
      } else {
        _this.options.WorkType = _this.mFilterNav[2];
      }

      _this.getData(_this.options);
      $(".m-recruit-nav>ul>li").removeClass("active");
      $(".dropDown").hide();
    },

    // 筛选 事件，无数据
    searchItemClick (index) {
      // this.searchActive = index;
    },
    // 工作地点 nav 点击事件
    adressItemClick (index) {
      let _this = this;
      let _name = _this.adressArr[index];

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      _this.adressActive = index;
      if (_name == "全部") {
        _this.options.AraeName = "";
      } else {
        _this.options.AraeName = _name;
      }
      // 从首页进来的搜索 input改变时 同步到url
      if (_this.$route.query.searchArea != undefined) {
        this.$router.push({
          name: "recruitIndex",
          query: { searchArea: encodeURI(_name) }
        });



      }

      _this.getData(_this.options);
    },
    // 职位类型 nav 点击事件
    workItemClick (index) {
      let _this = this;
      _this.workActive = index;

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      let _type = _this.workArr[index];
      if (_type == "全部") {
        _this.options.WorkType = "";
      } else {
        _this.options.WorkType = _type;
      }

      _this.getData(_this.options);
    },
    // 综合排序 nav 点击事件
    filterItemClick (index) {
      let _this = this;
      this.filterActive = index;
      let _sort = _this.filterNav[index];

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      if (_sort == "综合排序") {
        _this.options.SortType = "";
      } else {
        _this.options.SortType = _sort;
      }
      _this.getData(_this.options);
    },

    // 搜索 点击
    searchFilterClick () {
      let _this = this;

      // 筛选刷新 还原第一页
      _this.fullscreenLoading = true;

      _this.recruitDataArr = [];
      _this.options.PageIndex = 1;

      if (_this.SearchTxt != "") {
        _this.options.SearchTxt = _this.SearchTxt;
      } else {
        // console.log("无搜索条件")
        _this.options.SearchTxt = "";
      }
      // 从首页进来的搜索 input改变时 同步到url
      if (_this.$route.query.searchJob != undefined) {
        this.$router.push({
          name: "recruitIndex",
          query: { searchJob: encodeURI(_this.SearchTxt) }
        });
      }

      _this.getData(_this.options);
    },
    // 搜索条change
    changeSearchTxt () {
      this.options.SearchTxt = this.SearchTxt;
    },

    // 筛选
    queryData (options, data) {
      let _result = data;

      // // 首页直接搜索地区
      //  if(options.searchArea != ""){
      //   _result = _result.filter(item => {
      //     return item.WorkCity == options.searchArea;
      //   });
      // }

      if (options.AraeName != "") {
        _result = _result.filter(item => {
          return item.WorkCity == options.AraeName;
        });
      }

      if (options.WorkType != "") {
        _result = _result.filter(item => {
          return item.PositionCategory == options.WorkType;
        });
      }

      if (options.SortType == "最新发布") {
        _result = _result.sort(function (a, b) {
          return a["InDate"] < b["InDate"] ? 1 : -1;
        });
      }
      if (options.SortType == "最高薪酬" || options.SortType == "薪资最高") {
        _result = _result.sort(function (a, b) {
          return parseInt(b["MoneyEnd"]) - parseInt(a["MoneyEnd"]);
        });
        // _result = _result.sort(function(a,b){return parseInt((b['MoneyStart']+b['MoneyEnd'])/2) > parseInt((a['MoneyStart']+a['MoneyEnd'])/2) ? 1 : -1})
      }

      if (options.SearchTxt != "") {
        _result = _result.filter(item => {
          return (
            item.PositionName.toLowerCase().indexOf(
              options.SearchTxt.toLowerCase()
            ) != -1
          );
        });
      }

      // if(options.PageIndex >= 1){
      //   _result = _result.filter((item)=>{ return item.SysNo <= (options.PageSize * options.PageIndex) })
      // }

      return _result;
    }
  },
  computed: {
    // 最新日期 单日期补0
    newDate () {
      let data = new Date()
      let y = data.getFullYear()
      let m = data.getMonth() + 1
      let d = data.getDate()
      if (m > 0 && m <= 9) {
        m = '0' + m
      }
      if (d > 0 && d <= 9) {
        d = '0' + d
      }
      return `${y}-${m}-${d}`
    }
  },
  watch: {
    $route (to, from) {
      //和详情页 路由切换时 吸顶状态回到默认值
      $(".recruit-nav").css({
        position: "relative",
        top: "0"
      });
      // 监听 窗口滚动 吸顶效果  路由变化时  效果消失 所以重载
      window.addEventListener("scroll", this.handleScroll, true);
    }
  }
};
</script>

<style lang="less" scoped>
.recruit-banner {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .banner-content {
    padding: 12.2% 0 5%;
    text-align: center;
    .title {
      font-size: 0;
      img {
        width: 6.99rem;
      }
    }
    .titleDesc {
      margin-top: 0.35rem;
      font-size: 0;
      img {
        width: 5.52rem;
      }
    }
    .search {
      margin: 3.5% auto 1.2%;
      position: relative;
      width: 31%;
      input {
        padding: 4.2% 35% 4.2% 5%;
        width: 100%;
        font-size: 0.14rem;
        border: 2px solid #24b0e9;
        border-image: linear-gradient(#7cd6da, #6285ff) 2 2;
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
        width: 30%;
        height: 100%;
        color: #ffffff;
        font-size: 0.24rem;
        letter-spacing: 4px;
        text-indent: 4px;
        background: #24b0e9;
        background: linear-gradient(to bottom, #7cd6da, #6285ff);
        background: -webkit-linear-gradient(to bottom, #7cd6da, #6285ff);
        background: -moz-linear-gradient(to bottom, #7cd6da, #6285ff);
        background: -o-linear-gradient(to bottom, #7cd6da, #6285ff);
        cursor: pointer;
      }
    }
    .desc {
      margin: 0 auto;
      text-align: center;
      a {
        color: #ffffff;
        font-size: 0.14rem;
        margin: 0 0.12rem;
        padding-bottom: 0.02rem;
        &:hover,
        &.active {
          color: #24b0e9;
          border-bottom: 1px solid #24b0e9;
        }
      }
    }
  }
}
.recruit-nav-wrap {
  position: relative;
  width: 100%;
}
.recruit-nav {
  position: relative;
  top: 0;
  left: 50%;
  z-index: 10;
  width: 90%;
  padding: 2% 11.5% 0;
  background-color: #ffffff;
  transform: translateX(-50%);
  ul {
    padding: 1% 0;

    li {
      float: left;
      margin-right: 3%;
      color: #535353;
      cursor: pointer;
      &.active,
      &:hover {
        color: #24b0e9;
      }
      &:first-child {
        margin-right: 2%;
        cursor: default;
        &.active,
        &:hover {
          color: #535353;
        }
      }
    }
  }
  .filter-nav {
    position: relative;
    margin-top: 3.5%;
    padding-bottom: 1%;
    border-bottom: 1px solid #e5e5e5;
    & > div {
      span {
        margin-right: 2%;
        cursor: pointer;
        &.active,
        &:hover {
          color: #24b0e9;
        }
      }
    }
    & > p {
      position: absolute;
      top: 0;
      right: 0;
      span {
        color: #24b0e9;
      }
    }
  }
}
.recruit-list {
  position: static;
  padding: 0 16%;
  background-color: #ffffff;
  ul {
    li {
      width: 100%;
      padding: 4% 0 3%;
      color: #000000;
      border-bottom: 1px solid #eeeeee;
      transition: all 0.5s;
      .list-con {
        float: left;
        width: 50%;
        a {
          color: #000000;
        }
        .title {
          font-size: 0.24rem;
        }
        .content {
          margin: 5% 0;
          font-size: 0.14rem;
          color: #535353;
          span {
            display: inline-block;
            vertical-align: middle;
          }
          .price {
            color: #f02f2f;
            font-weight: 700;
            font-size: 0.18rem;
          }
          .tag {
            margin: 0 2%;
            padding: 0.2% 2%;
            color: #24b0e9;
            border: 1px solid #24b0e9;
            border-radius: 25px;
          }
          .adress {
            color: #535353;
            font-size: 0.14rem;
          }
        }
        .desc {
          span {
            padding: 0 2%;
            font-size: 0.14rem;
            color: #535353;
            border-left: 1px solid #d2d2d2;
            &:first-child {
              border-left: none;
              padding-left: 0;
            }
          }
        }
      }
      .list-logo {
        float: left;
        position: relative;
        width: 15%;
        min-height: 1.52rem;
        color: #535353;
        text-align: center;
        .img-box {
          img {
            max-width: 100%;
            max-height: 1rem;
          }
        }
        .time {
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 100%;
          font-size: 0.14rem;
          text-align: center;
          transform: translateX(-50%);
        }
      }
      .list-company {
        float: left;
        width: 35%;
        font-size: 0.18rem;
        text-align: center;
        .company-box {
          position: relative;
          min-height: 1.52rem;
          height: 100%;
          float: right;
          width: 52%;
          margin-right: 0;
          .company-name {
            color: #535353;
            line-height: 1.5;
          }
          .button {
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 80%;
            cursor: pointer;
            transform: translateX(-50%);
            display: inline-block;
            padding: 4.5% 0;
            letter-spacing: 0.4em;
            text-indent: 0.4em;
            border: 1px solid #000000;
            &:hover {
              color: #ffffff;
              background: #0f8ffd;
              border: 1px solid #0f8ffd;
              transition: all 0.3s;
            }
          }
        }
      }
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        .list-con {
          .title {
            color: #24b0e9;
          }
        }
      }
    }
    li.bottomLine {
      text-align: center;
      font-size: 0.14rem;
      color: #999;
    }
    li.noneData {
      text-align: center;
      padding-top: 5%;
      font-size: 0.18rem;
      color: #999;
    }
  }
}

.m-recruit-index-wrapper {
  position: relative;
  .m-recruit-nav {
    z-index: 10;
    width: 100%;
    background-color: #ffffff;
    & > ul {
      border-bottom: 1px solid #e9e9e9;
      & > li {
        position: relative;
        float: left;
        width: 33%;
        & > p {
          padding: 0.2rem 0 0.22rem 0.15rem;
          span {
            position: relative;
            font-size: 0.16rem;
            font-weight: bold;
            img {
              width: 0.08rem;
              position: absolute;
              top: 0.06rem;
              right: -0.2rem;
              transition: all 0.3s;
            }
          }
        }
        &.active {
          & > p {
            span {
              img {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
    }
    & > .dropDown {
      display: none;
      position: absolute;
      top: 0.61rem;
      left: 0;
      width: 100%;
      z-index: 5;
      background-color: #ffffff;
      li {
        position: relative;
        padding: 0.2rem 0.15rem;
        font-size: 0.16rem;
        border-top: 1px solid #e9e9e9;
        img {
          display: none;
          position: absolute;
          top: 0.2rem;
          right: 0.15rem;
          width: 0.25rem;
        }
        &.active {
          img {
            display: block;
          }
        }
      }
      &.show {
        display: block;
      }
    }
  }
  .m-content-wrapper {
    width: 100%;
    padding: 0 0.12rem;
    li {
      padding: 0.22rem 0;
      border-bottom: 0.01rem solid #e9e9e9;
      .left-content {
        width: 65%;
        float: left;
        & > a {
          display: block;
          .title {
            color: #000000;
            font-size: 0.16rem;
            font-weight: 700;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .content {
            margin: 0.05rem 0;
            font-size: 0.1rem;
            color: #535353;

            span {
              display: inline-block;
              vertical-align: middle;
            }
            .tag {
              margin-right: 0.07rem;
              padding: 0.01rem 0.07rem;
              color: #24b0e9;
              line-height: 1;
              border: 1px solid #24b0e9;
              border-radius: 0.1rem;
            }
          }
          .desc {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 0.1rem;
            color: #535353;
            span {
              padding: 0 0.07rem;
              border-left: 1px solid #d2d2d2;
              &:first-child {
                border-left: 0;
                padding-left: 0;
              }
            }
          }
          .time {
            margin: 0.1rem 0 0;
            font-size: 0.1rem;
            color: #535353;
          }
        }
      }
      .right-content {
        position: relative;
        width: 35%;
        min-height: 0.96rem;
        float: left;
        text-align: center;
        span {
          font-size: 0.14rem;
          font-weight: 700;
          color: #f02f2f;
        }
        .button {
          position: absolute;
          left: 50%;
          bottom: 0;
          font-size: 0.12rem;
          padding: 0.035rem 0;
          text-indent: 2px;
          letter-spacing: 2px;
          width: 60%;
          border: 1px solid #000000;
          transform: translateX(-50%);
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
    li.m-noneData {
      font-size: 0.14rem;
      color: #999;
    }
    li.bottomLine {
      font-size: 0.14rem;
      color: #999;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/recruit/recruitIndex.vue